import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../features/obj/objSlice";
import svg29 from "../../../assets/svg/svg29.svg";
import svg13 from "../../../assets/svg/svg13.svg";
import svg14 from "../../../assets/svg/svg14.svg";
import ConfirmModal from "../../../components/ConfirmModal";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import ProfileAdd from "./modal/ProfileAdd";

function ProfileTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { open, handleCancel, handleOpen } = useModalToggle();

  const url = "prof/get_profiles";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = () => {};

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: "api/v2/getFarmers",
        fullName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj(prodd));
    await navigate("/user/user-add");
  };
  const handleView = async (item) => {
    await dispatch(setActiveObj({ key: "profile", data: item }));
    await navigate("/user/profile-view-list");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "profile", data: item }));
    await navigate("/user/profile-view-list");
  };
  const handleDisable = (item) => {
    handleOpenDelete();
  };
  const handleAdd = async () => {
    await handleOpen();
  };

  const columns = [
    {
      title: "Name",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.profProfile}
          </div>
        );
      },
      sorter: (a, b) => a.profProfile.localeCompare(b.profProfile),
    },

    {
      title: "Actions",
      width: 50,
      render: (item) => (
        <div className="flex items-center gap-x-[1rem]">
          <button onClick={() => handleView(item)}>
            <img src={svg14} alt="svg14" />
          </button>
          <button onClick={() => handleDisable(item)}>
            <img src={svg13} alt="svg13" />
          </button>
        </div>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Profile" }]} />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex items-center justify-between ">
          <div className="form-add-h">All Profiles</div>
          <div className="w-[150px]">
            <button
              onClick={() => handleAdd()}
              className="cstm-btn-2 gap-x-[.5rem]"
            >
              <img src={svg29} alt="svg29" />
              <span className="">Add New</span>
            </button>
          </div>
        </div>
        <div className="mt-[1.5rem]">
          <Divider />
        </div>

        <div className="overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.31rem] w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.profId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Disable"
      />

      <ProfileAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />
    </div>
  );
}

export default ProfileTable;
